/**
 * Which address book the account Profile page edits.
 *
 * Any customer Recharge holds an address for edits that address, whatever their plans' status:
 * refills ship there, and a cancelled customer reactivating ships there too. Only customers
 * Recharge has no address for get their Shopify address book (what checkout pre-fills). A failed
 * Recharge load leaves an empty list that looks like "no addresses"; never fall through to
 * Shopify then, where a subscriber's edit would move no delivery.
 *
 * Plain script (window.AccountAddresses) so the Liquid portal can use it; also CommonJS for
 * scripts/account-addresses.test.mjs.
 */
(function (root) {
  function profileAddressSource(state) {
    if (state.loadFailed) return 'failed';
    return (state.addresses || []).length > 0 ? 'recharge' : 'shopify';
  }

  var api = { profileAddressSource: profileAddressSource };
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.AccountAddresses = api;
})(this);
